import Vue from 'vue';
import VueRouter from 'vue-router';
import Archive from '../views/Archive.vue';
import Product from '../views/Product.vue';
import Wishlist from '../views/Wishlist.vue';

Vue.use(VueRouter);
let routes = [
  {
    path: `${ws_vue_store.sub_urls.shop}`,
    alias: `${ws_vue_store.sub_urls.shop}/`,
    name: 'Archive',
    component: Archive,
  },
  {
    path: `/${ws_vue_store.sub_urls.category_base}/:category_slug+`,
    name: 'Archive',
    component: Archive,
  },
  {
    path: `${ws_vue_store.sub_urls.shop}/${ws_vue_store.sub_urls.wishlist}/:wishlist_uid?`,
    name: 'Wishlist',
    component: Wishlist,
  },
];

if( !document.getElementById('vue-store')) {
  // Non archive page product route
  routes.push({
    path: `/${ws_vue_store.sub_urls.product_base}/:slug`,
    name: 'Archive',
    component: Archive
  })
} else if(ws_vue_store.single_product_page_enabled == "1"){
  // Vue store built in product page
  routes.push({
    path: `/${ws_vue_store.sub_urls.product_base}/:slug`,
    name: 'Product',
    component: Product,
  })
} else {
  // Normal wordpress product page redirect processing
  routes.push({
    path: `/${ws_vue_store.sub_urls.product_base}/:slug`,
    beforeEnter(to, from, next) {
      // Save current Y position in case user returns
      sessionStorage.setItem(window.location.href, document.documentElement.scrollTop || document.body.scrollTop);

      // In case wordpress isn't in base url folder, as in "site.ee/wordpress"
      // then url's don't contain the subdirectory and would direct to broken link
      if(window.location.href != ws_vue_store.site_url + to.path){
        let baseurl = ws_vue_store.site_url + to.path;
        let newUrl = new URL(baseurl);
        Object.keys(to.query).forEach(q => {
          newUrl.searchParams.append(q, to.query[q]);
        })
        window.location.href = newUrl;
      }
    }
  })
}

const router = new VueRouter({
  base: ws_vue_store.base_url,
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
